export default "//cdn.scentbird.com/assets/frontbird-site/images/supplements_bf101d.png";